<template>
  <div class="AllType animate animate__fadeInRight">
    <div class="itemCar">
      <ul>
        <li v-for="(item, index) in data" :key="index">
          <figure class="c4-izmir">
            <img :src="imgUrl + item.img" alt="" />
            <figcaption id="figcaptionHover">
              <div class="c4-rotate-down-right">
                <h3>
                  {{ item.name }}
                  <hr />
                </h3>
              </div>
              <p>垂直式垃圾转运站</p>
              <p>水平式垃圾转运站</p>
              <p>联体式垃圾转运站</p>
              <p>移箱式垃圾转运站</p>
              <p>竖压式垃圾转运站</p>
            </figcaption>
          </figure>
          <div class="textCenter" @click="gotoDetails">
            查看详情<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  name: "",
  data() {
    return {
      imgUrl: this.$store.state.imgUrl,
    };
  },
  components: {},
  methods: {
    gotoDetails() {
      this.$router.push("/details");
    },
  },
};
</script>

<style scoped lang="less">
.AllType {
  width: 100%;
  .itemCar {
    width: 100%;
    height: 100%;
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 430px;
        height: 400px;
        margin-bottom: 25px;
        overflow: hidden;
        p {
          margin: 5px 0;
          padding-left: 50px;
        }
        img {
          vertical-align: middle;
        }
        div {
          height: 60px;
          line-height: 60px;
          color: #292e40;
          letter-spacing: 5px;
          cursor: pointer;
          i {
            font-family: "Microsoft YaHei";
          }
        }
      }
      li:hover {
        border-top: 0;
        box-shadow: 0px 0px 20px #cccccc;
        // transform: rotateX(360deg);
        transition: 0.5s;
      }
    }
  }
}

.textCenter {
  cursor: pointer;
}
</style>
